<template>
  <div>
    <modal :show.sync="modals.change"
           modal-classes="modal-dialog-centered modal-sm">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Изменить пользователя {{user.login}}</h5>
      </template>
      <div>
       <div class="container">
         <div class="row">
           <div class="col-sm-12">
             <base-input  type="text" label="E-mail" v-model="user.login"  placeholder="mail"/>
           </div>
           <div class="col-sm-12">
             <base-input  type="number" label="Телефон" v-model="user.phone" placeholder="Телефон"/>
           </div>
           <div class="col-sm-12">
             <base-input  type="text" label="ФИО" v-model="user.name" placeholder="ФИО"/>
           </div>
           <div class="col-sm-12">
             <base-input  type="number" label="Максимум устройств" v-model="user.maxSerials" placeholder="Максимум устройств"/>
           </div>
           <div class="col-sm-12 ">
             <h5 style="color: #525f7f">
               Окончание подписки
             </h5>
             <base-input>
               <el-date-picker v-model="user.date"
                               label="Окончание подписки"
                               type="date"
                               format="dd.MM.yyyy"
                               placeholder="Окончание подписки">

               </el-date-picker>
             </base-input>
           </div>

           <div class="col-sm-12 ">
             <base-checkbox inline class="mb-3 " v-model="user.owner">
               Покупка
             </base-checkbox>

           </div>
           <div class="col-sm-12 ">
             <h5>
               Количество использованных устройств: {{user.serial}}
             </h5>


           </div>

         </div>
       </div>
      </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <hr>
            </div>
            <div class="col-sm-4">
              <base-button simple @click="closeChange()" type="secondary"  >Закрыть</base-button>
            </div>
            <div class="col-sm-3"></div>
            <div class="col-sm-3">
              <base-button simple @click="saveChange()" type="success">Изменить</base-button>
            </div>
          </div>
        </div>



    </modal>
    <modal :show.sync="modals.changePass"
           modal-classes="modal-dialog-centered modal-sm">

      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h5 class="modal-title" id="exampleModalLabel"> Вы уверены что хотите изменить пароль  пользователя {{user.login}}</h5>
          </div>
          <div class="col-sm-12">
            <hr>
          </div>
          <div class="col-sm-4">
            <base-button simple @click="modals.changePass=false" type="secondary"  >Закрыть</base-button>
          </div>
          <div class="col-sm-3"></div>
          <div class="col-sm-3">
            <base-button simple @click="saveChangePass()" type="success">Изменить</base-button>
          </div>
        </div>
      </div>



    </modal>
    <modal :show.sync="modals.new"
           modal-classes="modal-dialog-centered modal-sm">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Добавить пользователя </h5>
      </template>
      <div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <base-input  type="text" label="E-mail" v-model="add.login"  placeholder="mail"/>
            </div>

            <div class="col-sm-12">
              <base-input  type="number" label="Телефон" v-mask="maskPhone" v-model="add.phone" placeholder="Телефон"/>
            </div>
            <div class="col-sm-12">
              <base-input  type="text" label="ФИО" v-model="add.name" placeholder="ФИО"/>
            </div>
            <div class="col-sm-12">
              <base-input  type="number" label="Максимум устройств" v-model="add.maxSerials" placeholder="Максимум устройств"/>
            </div>
            <div class="col-sm-12 mt-3">
              <base-input>

                <el-date-picker v-model="add.date"
                                :picker-options='{
                                "firstDayOfWeek":1,

                                }'
                                label="Окончание подписки"
                                type="date"
                                format="dd.MM.yyyy"
                                placeholder="Окончание подписки">

                </el-date-picker>
              </base-input>
            </div>

            <div class="col-sm-12 ">
              <base-checkbox inline class="mb-3 " v-model="add.owner">
                Покупка
              </base-checkbox>

            </div>

          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <hr>
          </div>
          <div class="col-sm-4">
            <base-button simple @click="modals.new = false" type="secondary"  >Закрыть</base-button>
          </div>
          <div class="col-sm-3"></div>
          <div class="col-sm-3">
            <base-button simple @click="addNewUSer()" type="success">Добавить</base-button>
          </div>
        </div>
      </div>



    </modal>
    <modal :show.sync="modals.dell"
           modal-classes="modal-dialog-centered modal-sm">

      <div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">

              <h5 class="modal-title text-center" >Вы уверены, что хотитие удалить пользователя ? </h5>

          </div>
          <div class="col-sm-12">
            <hr>
          </div>
          <div class="col-sm-4">
            <base-button simple @click="modals.dell = false" type="secondary"  >Закрыть</base-button>
          </div>
          <div class="col-sm-3"></div>
          <div class="col-sm-3">
            <base-button simple @click="dellUser()" type="danger">Удалить</base-button>
          </div>
        </div>
      </div>



    </modal>

    <card>
      <form @submit.prevent>
      <div  class="container mt-2 mb-3 case">
        <div class="row">
          <div class="col-sm-4">
            <base-button simple @click="newUser()" type="success">Добавить пользователя</base-button>
          </div>
          <div class="col-sm-2">

          </div>
          <div class="col-sm-2">
            <el-select class="select-danger mt-2"
                       placeholder="5"
                       v-model="selectsSimple2"
            >

              <el-option v-for="option in selects2.pages"
                         class="select-danger"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>

          <div class="col-sm-4 mt-2">
            <base-input addon-left-icon="tim-icons icon-zoom-split" placeholder="Поиск пользователя" v-model="search"></base-input>
          </div>



        </div>
      </div>
      <hr>
      <el-table clsss="mt-3" :data="tableData"
        @header-click="sortStatusFun"
      >
        <el-table-column min-width="60" type="index"></el-table-column>
        <el-table-column min-width="350" prop="login"
                         label="E-mail">
          <template slot-scope="scope" >
            <div class="container">
              <div class="row">
                <div class="col-sm-3">
                  <base-button link @click="dell(scope.row)" round simple  type="danger">
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
                <div class="col-sm-6">
                 <p>{{ scope.row.login }}</p>
                </div>
                <div class="col-sm-3">
                  <base-button link  content="Изменить информацию о пользователе" round simple @click="changeModal(scope.row)"  type="info">
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column min-width="150" prop="phone"
                         label="Телефон">
        </el-table-column>
        <el-table-column min-width="150" prop="name"
                         label="ФИО">
        </el-table-column>
        <el-table-column
          prop="status"
          label="Купил"
          width="100">
          <template slot-scope="scope" >
            <p :class=" {
                      successText:scope.row.status === 'Да',
                      dangerText:scope.row.status === 'Нет',}">
              {{ scope.row.status }}
            </p>
          </template>
        </el-table-column>
        <el-table-column min-width="170" prop="maxSerials"
                         label="макс устройств">
        </el-table-column>
        <el-table-column width="240" prop="subscribePeriod"
                         label="Окончание подписки"

                         >

        </el-table-column>

        <el-table-column min-width="220"
                         header-align="right"
                         label="Действия">
          <div slot-scope="scope" class="text-right">


            <el-tooltip class="ml-3" content="Сбросить пароль"
                        :open-delay="200"
                        placement="top">
              <base-button type="warning"  simple  @click="changePassModal(scope.row)">
                Сбросить пароль
              </base-button>
            </el-tooltip>



          </div>
        </el-table-column>
      </el-table>
      <hr>
      <div class="container">
        <div class="row ">

          <div class="col-sm-5 col-xl-7 col-md-4"></div>
          <div class="col-sm-2 col-xl-2 col-md-2 mt-2 text-center">Элементов на странице:</div>

          <div class="col-sm-2 col-xl-1 col-md-2">

            <el-select class="select-danger"
                       placeholder="5"
                       v-model="selectsSimple"
            >

              <el-option v-for="option in selects.pages"
                         class="select-danger"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>

          </div>
          <div class="col-sm-1 col-xl-1 col-md-2 mt-2 text-center">{{showPrev}}-{{show}} of {{length}}</div>
          <div class="col mt-2 "> <i @click="prev()" class="tim-icons icon-minimal-left"> </i>  </div>
          <div class="col mt-2 " > <i  @click="next()" class="tim-icons icon-minimal-right"> </i></div>



        </div>
      </div>
      </form>
    </card>
  </div>
</template>
<script>
  import {DatePicker, TimeSelect} from 'element-ui'
  import {Table, TableColumn} from 'element-ui'
  import {Select, Option} from 'element-ui';
  import moment from 'moment';
  import {Modal} from 'src/components'
  import {mask} from 'v-mask'
  export default {
    name: 'Tracks',
    directives: {
      mask,
    },
    components: {

      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
       [DatePicker.name]: DatePicker,
     [TimeSelect.name]: TimeSelect,
      [Option.name]: Option,
      Modal,
      moment
    },

    methods: {
      interface: async function (take, skip, search) {
          if (take === undefined){
              take = 5;
              skip = 0;
              search = '';
          }
          console.log(take,skip,search);
        let status1;
        let filter = JSON.stringify({
          search:search,
          owner:this.owner
          });
        let sort = JSON.stringify({
          subscribePeriod:this.sortStatus});

        let token = this.$store.getters.getToken;

        try{
          let response = await axios({
            method: 'GET',
            url: '/api/admin/subscribers/get' + '?take=' + take + '&skip=' + skip +'&filters='+filter +'&sort=' + sort ,
            headers: {
              'token': token
            },
          });
            this.tableData = [];
          for (let i = 0; i < response.data.subscribtions.length; i++) {
            let status;
            if (response.data.subscribtions[i].owner === true)
              status = 'Да';
            else
              status = 'Нет';
            let serial;
            let serialLength;
            if (response.data.subscribtions[i].serial){
              serial = response.data.subscribtions[i].serial;
              serialLength = serial.length
            }

            //maxSerials - максимум устройств subscribePeriod - срок действия подписки owner - купил или нет
            this.tableData.push({
              index: i + 1,
              login: response.data.subscribtions[i].login? response.data.subscribtions[i].login:' ',
              password: response.data.subscribtions[i].password?response.data.subscribtions[i].password:' ',
              maxSerials: response.data.subscribtions[i].maxSerials?response.data.subscribtions[i].maxSerials:' ',
              status: status,
              name:  response.data.subscribtions[i].name?response.data.subscribtions[i].name:' ',
              phone:  response.data.subscribtions[i].phone?response.data.subscribtions[i].phone:' ',
              serial: serialLength,
              date:response.data.subscribtions[i].subscribePeriod?response.data.subscribtions[i].subscribePeriod:'',
              subscribePeriod:moment(response.data.subscribtions[i].subscribePeriod).format('DD.MM.YYYY')?moment(response.data.subscribtions[i].subscribePeriod).format('DD.MM.YYYY'):' ',
              id: response.data.subscribtions[i]._id,

            });


          }

          this.length = response.data.count;
          this.showPrev = 1+skip;
          if (this.showPrev===1){
            this.show = this.selectsSimple
          }
          else {
            this.show=this.show+ this.selectsSimple
          }
          if (this.show> this.length){
            this.show = this.length
          }
        }catch (e) {
          localStorage.removeItem('token');
          localStorage.removeItem('CurrentRelease');
          localStorage.removeItem('getCurrentTrack');
          localStorage.removeItem('currentReleases');
          localStorage.clear('token')
          console.log('вышел');
          this.$router.push('/login');
        }




      },
      async closeChange(){
        this.modals.change = false
        let take = 5;
        let skip = 0;
        let search = '';
        this.interface(take,skip,search);

      },
      newUser(){
        this.add={
          login: '',
            maxSerials:5,
            owner:false,
            password:'',
            phone:null,
            name:'',
            date: new Date().getTime()+31536000*1000,
        };
        this.modals.new = true;
      },
      async addNewUSer(){
        console.log(this.add)
        if (this.add.owner ===''){
          this.add.owner  = false;
        }
        let token = this.$store.getters.getToken;
        let response = await axios({
          method: 'POST',
          url: '/api/admin/subscribers/add',
          headers: {
            'token': token
          },
          data:{
            login: this.add.login,
            password: this.add.password,
            subscribe: this.add.date,
            owner: this.add.owner,
            serialsCount: this.add.maxSerials,
            name:this.add.name,
            phone:this.add.phone

          }
        });
        if (response.data.status === 'OK'){
          this.$notify({type: 'success', message: 'Пользователь успешно изменен'});
          let take = 5;
          let skip = 0;
          let search = '';
          this.interface(take,skip,search)
          this.modals.new = false
        }
        else{
          if (response.data.err ==='PLATFORM_ERROR_EXISTING_SUBSCRIBE'){
            this.$notify({type: 'danger', message: 'Данный пользователь уже существует'});
          }else{
          this.$notify({type: 'danger', message: 'Системная ошибка'});}}
      },
      async saveChangePass(){
        if (this.change.password === this.change.passwordRepeat){
          let token = this.$store.getters.getToken;
          let response = await axios({
            method: 'POST',
            url: '/api/admin/subscribers/' + this.change.id + '/password/change',
            headers: {
              'token': token
            },
            data:{
              password: this.change.password,

            }
          });
          if (response.data.status === 'OK'){
            this.$notify({type: 'success', message: 'Письмо для удаления пароля отправлено на почту'});
            let take = 5;
            let skip = 0;
            let search = '';
            this.interface(take,skip,search)
            this.modals.changePass = false
          }
          else
            this.$notify({type: 'danger', message: 'Системная ошибка'});
        }else {
          this.$notify({type: 'danger', message: 'Пароли не совпадают'});
        }
      },
      async saveChange(){

        let token = this.$store.getters.getToken;
        let response = await axios({
          method: 'POST',
          url: '/api/admin/subscribers/' + this.user.id + '/set',
          headers: {
            'token': token
          },
          data:{
            login: this.user.login,
            subscribe: this.user.date,
            owner: this.user.owner,
            phone: this.user.phone,
            name: this.user.name,
            serialsCount: this.user.maxSerials,

          }
        });
        if (response.data.status === 'OK'){
          this.$notify({type: 'success', message: 'Пользователь успешно изменен'});
          let take = 5;
          let skip = 0;
          let search = '';
          this.interface(take,skip,search)
          this.modals.change = false
        }
        else
          this.$notify({type: 'danger', message: 'Системная ошибка'});
      },

      sidebarProp: function () {
        this.$sidebar.toggleMinimize();
      },


      changePassModal(row){
        console.log(row)
        this.change.password = '';
        this.change.passwordRepeat = '';
        this.change.id = row.id;
        this.modals.changePass = true;
      },
      async dell(row){
        console.log(row.id)
        this.idUser = row.id
        this.modals.dell = true;
      },
      async dellUser(){
        let token = this.$store.getters.getToken;
         let response = await axios({
           method: 'DELETE',
           url: '/api/admin/subscribers/'+this.idUser+'/remove',
           headers: {
             'token': token
           },

         });
         if (response.data.status === 'OK'){
           this.$notify({type: 'success', message: 'Пользователь удален успешно!'});
           let take = 5;
           let skip = 0;
           let search = '';
           this.modals.dell = false;
           this.interface(take, skip, search)
         }

  },
      changeModal: async function (row) {
        console.log(row)
        this.modals.change = true;
        this.user = row;
        if (row.status === 'Да')
          this.user.owner = true;
        else
          this.user.owner = false;

      },

      prev: async function () {
        if (this.showPrev !== 1) {
          let search = this.search;
          let take = this.selectsSimple;
          let skip = this.showPrev - this.selectsSimple - 1
          this.interface(take, skip, search)
        }

      },
      next: async function () {
        if (this.show !== this.length) {
          let search = this.search;
          let take = this.selectsSimple;
          let skip = this.showPrev + this.selectsSimple - 1
          this.interface(take, skip, search)
        }

      },
        sort(val){
          switch (val) {
            case -1:
              return null;
            case 1:
              return  -1;
            case null:
              return  1;
            default:
              return null;
          }

      },
      sortStatusFun(col){
        console.log(col);
        if (col.label === 'Окончание подписки'){
          this.sortStatus = this.sort(this.sortStatus)
          console.log('123');
        let take = 5;
        let skip = 0;
        this.interface()}
      },
    },
      async mounted() {
       if (!this.$store.getters.getToken)
         this.$router.push('/login');
        this.status = 1;
        let take = 5;
        let skip = 0;
        let search = '';
        this.interface(take, skip, search)
      },
      watch: {

          selectsSimple2: async function (val) {
                console.log(val)
            if (val === 'Поиск по покупке' ){
              this.owner = null;
            }else{
              if (val === null){
                this.owner = null;
              }else{
                this.owner = JSON.stringify(val)
              }


            }
            let take = this.selectsSimple;
            let skip = 0;
            this.status = val;
            let search = '';
            this.interface(take, skip, search)

            },
        selectsSimple: async function (val) {
          this.selectsSimple=val;
          let take = this.selectsSimple;
          let skip = 0;
          let search = '';
          this.interface(take, skip, search)
        },
        search: async function (val) {
          let take = this.selectsSimple;
          let skip = 0;
          let search = val;
            this.search = val;
          this.interface(take, skip, search)
        }

      },
    data() {

      return {
        add:{
          login: '',
          maxSerials:'',
          owner:5,
          password:'',
          subscribePeriod:'',
          name:'',
          phone:null
        },
        change:{
          id:null,
          password: '',
          passwordRepeat:'',
        },
        sortStatus: null,
        idUser:null,
        /* 1*/
        maskPhone: '+7 (###) ###-##-##',
        tableData: [],
        show: 5,
        showPrev: 1,
        skip: 0,
        owner: null,
        user: {},
        modals:{
          dell:false,
          change:false,
          new: false,
          changePass: false,
        },
        selects: {
          pages: [{value: 5, label: 5},
            {value: 10, label: 10},
            {value: 20, label: 20}],

        },
        selects2: {
          pages: [{value: null, label: 'Все'},
            {value: 0, label: 'Не купил'},
            {value: 1, label: 'Купил'},]


        },

        selectsSimple2: 'Поиск по покупке',
        selectsSimple: 5,
        status:0,

        length: null,
        search: '',
      };
    },


  }
</script>
<style>
  @media (min-width: 1200px) {
    .case {
      max-width: 1500px !important;
      margin-right: 0px!important;
      margin-left: 0px!important;
    }
  }

  .dangerText{
    color: red !important;
  }
  .expectationText{
    color:#1d8cf8 !important;
  }
  .successText{
    color: #18ce0f;
  }
  .successsText{
    color: #18ce0f;
  }

  .dangerText{
    color: red !important;
  }
  .warningText{
    color:#ff8d72!important;
  }
  .warningText1{
    color:#ff8d72!important;
  }
</style>
